/**
 * Feature flags
 */

// enum value must match flag key in LaunchDarkly
export enum FeatureFlag {
    AI_SITES = 'ai-sites',
    ALLOW_EMAIL_LINKS = 'allow-email-links',
    ALLOW_SMS_LINKS = 'allow-sms-links',
    ALLOWED_TEST_RECIPIENTS = 'allowed-test-recipients',
    ATOM_REFERRALS = 'atom-referrals',
    CAMPAIGNS_V2_OBJECTIVE_BOOKINGS = 'campaigns-v2-objective-bookings',
    CAMPAIGNS_V2_UNSUBSCRIBE_COLUMN = 'campaigns-v2-unsubscribe-column',
    COMPANY_IS_VERIFIED = 'company-is-verified',
    JOBBER_CUSTOM_FIELD = 'jobber-custom-field',
    MULTI_FACTOR_AUTHENTICATION = 'multi-factor-authentication',
    BROADCAST_CAMPAIGN = 'broadcast-campaign',
    NPS_CAMPAIGN = 'nps-campaign',
    ONBOARDING_WITH_PHONE_VERIFICATION_DISABLED = 'onboarding-with-phone-verification',
    RECOMMENDATION_LEAD_ALERT = 'recommendation-lead-alert',
    RECOMMENDATIONS = 'recommendations',
    SEND_TEST_MESSAGE = 'send-test-message',
    USE_SUGARWISH_TEST_ACCOUNT_IN_PRODUCTION = 'use-sugarwish-test-account-in-production',
}

export interface IMLModelConfig {
    version: {
        major: MLModelMajorVersion;
        minor: MLModelMinorVersion;
    };
}

// model major version
export enum MLModelMajorVersion {
    V1 = 'ionian',
    V2 = 'dorian',
    V3 = 'phrygian',
    V4 = 'lydian',
    V5 = 'mixolydian',
    V7 = 'aeolian',
    V8 = 'locrian',
}

// model minor version
export enum MLModelMinorVersion {
    V1 = 'unison',
    V2 = 'minor_second',
    V3 = 'major_second',
    V4 = 'minor_third',
    V5 = 'major_third',
    V6 = 'perfect_fourth',
    V7 = 'tritone',
    V8 = 'perfect_fifth',
    V9 = 'minor_sixth',
    V10 = 'major_sixth',
    V11 = 'minor_seventh',
    V12 = 'major_seventh',
    V13 = 'octave',
    V14 = 'compound_minor_second',
    V15 = 'compound_major_second',
    V16 = 'compound_minor_third',
    V17 = 'compound_major_third',
    V18 = 'compound_perfect_fourth',
    V19 = 'compound_tritone',
    V20 = 'compound_perfect_fifth',
    V21 = 'compound_minor_sixth',
    V22 = 'compound_major_sixth',
    V23 = 'compound_minor_seventh',
    V24 = 'compound_major_seventh',
    V25 = 'double_octave',
}

/**
 * Feature flag check result types
 */
export interface FeatureFlagCustomCheckResultMap {
    // example: [FeatureFlag.ALLOW_EMAIL_LINKS]: AllowEmailLinksResult;
}

export type FeatureFlagCheckResult<
    Flag extends FeatureFlag | 'default'
> = Flag extends keyof FeatureFlagCustomCheckResultMap
    ? FeatureFlagCustomCheckResultMap[Flag]
    : boolean;
